<div class="dealer-select">
  <app-dropdown
    [label]="''"
    dropdownId="groupDropDown"
    [options]="groupList"
    [searchable]="true"
    placeholder="Select group"
    displayKey="groupMemberCode"
    [default]="selectedGroup"
    trackKey="groupMemberCode"
    (valueChange)="onGroupSelect($event)"
    [disabled]="isGroupDropdownDisabled"
  ></app-dropdown>
  @if (orgDetails?.length) {
    <span>|</span>
    <app-dropdown
      [label]="GroupName || ''"
      dropdownId="dealerDropDown"
      [options]="orgDetails"
      placeholder="Select a dealer"
      displayKey="orgNickName"
      [default]="selectedDealer"
      trackKey="groupMemberCode"
      (valueChange)="onSelect($event)"
      [disabled]="isDealerDropdownDisabled"
    />
  }
</div>
